import React from 'react';
import { useHistory } from 'react-router-dom';
import StatePage from '../../../components/StatePage/StatePage';
import { Changepasswordcontext } from '../../../context/Changepassword/Changepassword';

const ChangePasswordSuccess = () => {
  const [counter, setCounter] = React.useState(5);
  const { clearContext } = React.useContext(Changepasswordcontext);
  const history = useHistory();

  React.useEffect(() => {
    if (counter === 0) {
      clearContext();
      history.replace('/login');
      return;
    }
    const timer = window.setTimeout(() => setCounter((value) => value - 1), 1000);
    return () => window.clearTimeout(timer);
  }, [counter, history, clearContext]);

  return <StatePage icon="check" eyebrow="Contraseña actualizada" title="Cambio realizado correctamente" text={`Te llevaremos a iniciar sesión en ${counter} s.`} actionLabel="Ir a iniciar sesión" actionTo="/login" actionOnClick={clearContext} />;
};

export default ChangePasswordSuccess;
